import { forwardRef } from 'react';
import { RadiobuttonCheckedIcon, RadiobuttonUncheckedIcon } from 'icons';

import { Checkbox, CheckboxPropTypes } from './checkbox';

export const Radiobutton = forwardRef((props, ref) => (
	<Checkbox
		{...props}
		type="radio"
		iconChecked={RadiobuttonCheckedIcon}
		iconUnchecked={RadiobuttonUncheckedIcon}
	/>
));

Radiobutton.propTypes = {
	...CheckboxPropTypes,
};
